import React from "react";

const InsTable = ({ data = [], loading }) => {
    if (loading) return <p className="p-4 text-blue-500">Loading...</p>;
    if (!data || data.length === 0)
        return <p className="p-4 text-gray-500">No data available</p>;

    return (
        <div className="p-4">
            <table className="min-w-full border border-blue-500 bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-left">Total No. Vehicle</th>
                        <th className="px-4 py-2 text-left">Insurance Available</th>
                        <th className="px-4 py-2 text-left">Expiring (0–30 Days)</th>
                        <th className="px-4 py-2 text-left">Expiring (31–60 Days)</th>
                        <th className="px-4 py-2 text-left">Expiring (61–90 Days)</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, i) => (
                        <tr
                            key={i}
                            className={i % 2 === 0 ? "bg-white" : "bg-blue-50"}
                        >
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.totalNoVehicle}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.insuranceAvaialble}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.insuranceExpiring1}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.insuranceExpiring2}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.insuranceExpiring3}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default InsTable;
